import { UserContext } from 'providers/UserProvider';
import { useContext, useEffect, useState } from 'react';
import { PaywallaxSelector } from './PaywallaxMarkIIStyles';

const PaywallaxMarkII = () => {
  const { showPaywallax } = useContext(UserContext);
  const [displayContainer, setDisplayContainer] = useState(false);

  useEffect(() => {
    if (showPaywallax) setDisplayContainer(true);
  }, [showPaywallax]);

  return <PaywallaxSelector className={`paywallax-ii-selector ${displayContainer ? 'loaded' : 'initial'}`} />;
};

export default PaywallaxMarkII;
